import { render, staticRenderFns } from "./ManageStructures.vue?vue&type=template&id=04ff4cdc"
import script from "./ManageStructures.vue?vue&type=script&lang=js"
export * from "./ManageStructures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports